import { render, staticRenderFns } from "./Salary.vue?vue&type=template&id=90de920c&scoped=true"
import script from "./Salary.vue?vue&type=script&lang=js"
export * from "./Salary.vue?vue&type=script&lang=js"
import style0 from "./Salary.vue?vue&type=style&index=0&id=90de920c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90de920c",
  null
  
)

export default component.exports